import React from "react";
import axios from "axios";
import moment from "moment";

import { downloadFile } from "../../functions.js";
import StudentsIndexlinks from "./indexLinks";

export default class StudentsFiles extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            file: null,
            is_active: 1,
            files: []
        };
    }

    fileUpload = (e) => {
        e.preventDefault();
        const url = `/v1/users/${this.props.params.itemID}/files/`;

        if (this.state.file && this.state.file.name) {
            const formData = new FormData();
            formData.append("file", this.state.file, this.state.file.name);

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Content-Disposition": `attachment; filename="${this.state.file.name}"`
                }
            };
            axios
                .put(url, formData, config)
                .then((response) => {
                    // Refresh the data
                    this.getResults();
                    this.setState({
                        file: null
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    handleFileChange = (e) => {
        this.setState({
            [e.target.name]: e.target.files[0]
        });
    };

    deleteFile = (e, fileID) => {
        e.preventDefault();

        if (confirm("Weet je zeker dat je  dit bestand wilt verwijderen bij deze gebruiker?")) {
            axios
                .delete(`/v1/users/${this.props.params.itemID}/files/${fileID}/`)
                .then((response) => {
                    this.getResults();
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    getResults = () => {
        axios
            .get("/v1/students/" + this.props.params.itemID + "/")
            .then((response) => {
                this.setState({
                    loaded: true,
                    ...response.data
                });
            })
            .catch((error) => {
                console.log(error);
            });
        axios
            .get(`/v1/users/${this.props.params.itemID}/files/`)
            .then((response) => {
                this.setState({
                    files: response.data.results
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    componentDidMount() {
        this.getResults();
    }

    render() {
        let resultHTML = <h2>Ophalen van gegevens...</h2>;

        if (this.state.loaded) {
            let fileRows = [];

            if (this.state.files.length === 0) {
                fileRows.push(
                    <tr key="0">
                        <td colSpan="3">Geen gekoppelde bestanden gevonden.</td>
                    </tr>
                );
            } else {
                this.state.files.forEach((file) => {
                    if (file.type == null) {
                        fileRows.push(
                            <tr key={`file-${file.uuid}`}>
                                <td
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        downloadFile(`${APP_CONFIG.api_url}/v1/users/${this.props.params.itemID}/files/${file.uuid}/`, file.file_name);
                                    }}
                                >
                                    {file.file_name}
                                </td>
                                <td
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        downloadFile(`${APP_CONFIG.api_url}/v1/users/${this.props.params.itemID}/files/${file.uuid}/`, file.file_name);
                                    }}
                                >
                                    <span className="lighter">{moment(file.uploaded_datetime).format("DD-MM-YYYY")}</span>
                                </td>
                                <td width="30">
                                    <button
                                        className="btn btn-outline-secondary"
                                        onClick={(e) => {
                                            this.deleteFile(e, file.uuid);
                                        }}
                                    >
                                        X
                                    </button>
                                </td>
                            </tr>
                        );
                    }
                });
            }

            let fileSection = (
                <div key="files">
                    <table className="table table-hover table-clickable mt-3">
                        <thead>
                            <tr>
                                <th>Bestandsnaam</th>
                                <th>Datum van toevoegen</th>
                                <th>Actie</th>
                            </tr>
                        </thead>
                        <tbody>{fileRows}</tbody>
                    </table>

                    <h2>Nieuw bestand toevoegen</h2>
                    <input type="file" name="file" className="form-control-file" onChange={this.handleFileChange} />
                    <br />
                    <button className="btn btn-primary" onClick={(e) => this.fileUpload(e)}>
                        Bestand uploaden
                    </button>
                </div>
            );
            resultHTML = fileSection;
        }

        return (
            <div>
                <StudentsIndexlinks
                    title={this.state.full_name}
                    nibhv_number={this.state.nibhv_number}
                    studentUUID={this.props.params.itemID}
                    buttons={[{ title: "Cursist bewerken", link: "/students/edit/" + this.props.params.itemID, classname: "btn btn-primary" }]}
                />

                {resultHTML}
            </div>
        );
    }
}
